export default __webpack_public_path__ + "static/media/folder_content.0b8d4fdd.png";